import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

import PopupOverlay from '../features/PopupOverlay';

// Without this, document.title only refreshes on a full page load — the SSR
// path mounts a server-rendered <title> but SPA navigation never updates it,
// so the browser tab stays on whatever the last hard-load set.
const BASE_TITLE = '가까운솔루션';
const STATIC_TITLES = {
    '/': BASE_TITLE,
    '/about': `회사소개 | ${BASE_TITLE}`,
    '/use-cases': `구축 사례 | ${BASE_TITLE}`,
    '/products': `제품 및 규격 | ${BASE_TITLE}`,
    '/solutions': `솔루션 소개 | ${BASE_TITLE}`,
    '/partners': `시스템 연동·ESL 제조사 파트너 | ${BASE_TITLE}`,
    '/demo': `데모 요청 | ${BASE_TITLE}`,
    '/estimate': `3분 셀프견적 | ${BASE_TITLE}`,
    '/contact': `문의하기 | ${BASE_TITLE}`,
    '/support': `지원센터 | ${BASE_TITLE}`,
    '/privacy': `개인정보처리방침 | ${BASE_TITLE}`,
    '/terms': `이용약관 | ${BASE_TITLE}`,
};

const Layout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        // Detail pages (/solutions/:id, /products/:id, /use-cases/:id) set their
        // own per-item title from the loaded entity — skip them here so we
        // don't briefly overwrite a more specific title.
        if (/^\/(solutions|products|use-cases)\/[^/]+/.test(path)) return;
        // Support routes can have a trailing sub-path; map them all to the
        // base support title.
        if (path.startsWith('/support')) {
            document.title = STATIC_TITLES['/support'];
            return;
        }
        document.title = STATIC_TITLES[path] || BASE_TITLE;
    }, [location.pathname]);

    return (
        <div className="layout">
            <Header />
            <PopupOverlay />
            <main style={{ minHeight: '80vh', paddingTop: 'var(--header-height)' }}>
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
